import { Controller } from "stimulus"

/**
 * ## PacketFormatWarningController
 *
 * # Names, as files are chosen, each one the printed agenda packet will leave out. The packet
 * # merges PDFs only, judged by content type the same way Agenda::OutlinePacket::DocumentFormat
 * # judges the uploaded blob. A warning only: the upload still goes ahead.
 */
export default class extends Controller {
  static targets = ["input", "warning"]

  static PDF_TYPE = "application/pdf"

  check() {
    const names = Array.from(this.inputTarget.files || [])
      .filter((file) => file.type !== this.constructor.PDF_TYPE)
      .map((file) => file.name)

    this.warningTarget.replaceChildren(...names.map((name) => this._message(name)))
    this.warningTarget.classList.toggle("hidden", names.length === 0)
  }

  _message(name) {
    const paragraph = document.createElement("p")
    const filename = document.createElement("strong")
    filename.textContent = name
    paragraph.append(filename, " won't be included in the printed packet. Upload a PDF to include it.")
    return paragraph
  }
}
